import { useMatch } from '@tanstack/react-router';

export type OwnRouteParams = {
  route: string;
  params: Record<string, string | undefined>;
  query: Record<string, string | undefined>;
};

/**
 * The state.routeParams shape, read off this component's own route match.
 *
 * route_params_sync publishes state.routeParams synchronously on every history
 * change, but TanStack keeps the outgoing page rendered while the next route's
 * beforeLoad and lazy chunk resolve. An outgoing page therefore re-renders with
 * the *next* route's values and re-runs its route-keyed effects against them —
 * that is how navigating from a collection to an asset used to refire
 * getSearchItems() as an unfiltered root search, and how the cleanup then wiped
 * the listIds the asset page's prev/next depends on.
 *
 * A match-keyed read is frozen for the lifetime of the match, so the outgoing
 * page never observes the incoming route.
 *
 * TODO(FE-7111): interim shape — migrate consumers to typed per-route params.
 * https://linear.app/iconik/issue/FE-7111
 */
export function useOwnRouteParams(): OwnRouteParams {
  return useMatch({
    strict: false,
    select: (match): OwnRouteParams => ({
      route: match.staticData.v5Pattern ?? '',
      params: match.params,
      query: match.search,
    }),
  });
}
